import { sessionPrefix } from "./helpers";

export const inventoryItemTypesPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/inventory`;
export const inventoryItemTypePath = (session: LightSessionInterface, itemType: InventoryItemType) =>
  `${sessionPrefix(session)}/inventory/${itemType.id}`;
export const editInventoryItemTypePath = (session: LightSessionInterface, itemType: InventoryItemType) =>
  `${sessionPrefix(session)}/inventory/${itemType.id}/edit`;
export const newInventoryItemTypePath = (session: LightSessionInterface) => `${sessionPrefix(session)}/inventory/new`;

export const inventoryImportDguvPath = (session: LightSessionInterface) =>
  `${sessionPrefix(session)}/inventory/dguv-import`;
export const dguvCheckListPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/inventory/needs-check`;
export const handoverItemsPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/inventory/handover`;
export const handbackItemsPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/inventory/handback`;

type InventoryItemPathItemType = Pick<InventoryItemType, "id">;
type InventoryItemPathItem = Pick<InventoryItem, "id" | "itemTypeId">;

export const inventoryItemPath = (
  session: LightSessionInterface,
  itemType: InventoryItemPathItemType,
  item: InventoryItemPathItem,
) => `${sessionPrefix(session)}/inventory/${itemType.id}/${item.id}`;
export const soloInventoryItemPath = (session: LightSessionInterface, item: InventoryItemPathItem) =>
  `${sessionPrefix(session)}/inventory/${item.itemTypeId}/${item.id}`;

export const inventorySetsPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/inventory/sets`;
export const editInventorySetPath = (session: LightSessionInterface, set: InventorySet) =>
  `${sessionPrefix(session)}/inventory/sets/${set.id}/edit`;
export const newInventorySetPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/inventory/sets/new`;

export const inventoryReservationsPath = (session: LightSessionInterface) =>
  `${sessionPrefix(session)}/inventory/reservations`;
export const newInventoryReservationPath = (session: LightSessionInterface) =>
  `${sessionPrefix(session)}/inventory/reservations/new`;
export const editInventoryReservationPath = (session: LightSessionInterface, reservation: InventoryReservation) =>
  `${sessionPrefix(session)}/inventory/reservations/${reservation.id}/edit`;
export const handoverInventoryReservationPath = (session: LightSessionInterface, reservation: InventoryReservation) =>
  `${sessionPrefix(session)}/inventory/reservations/${reservation.id}/handover`;

export const inventoryUsersPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/inventory/users`;
export const showInventoryUserPath = (session: LightSessionInterface, user: UserRef) =>
  `${sessionPrefix(session)}/inventory/users/${user.id}`;
